var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4103_27671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7363 6.45264V10.9264L26.2392 8.39655L22.7363 6.45264Z",
    fill: "#52ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26362 6.45264L0.760742 8.39655L4.26362 10.9264V6.45264Z",
    fill: "#52ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9169 19.0501C13.7924 19.1394 13.6468 19.1851 13.5 19.1851C13.3532 19.1851 13.2076 19.1404 13.0831 19.0501L0 9.60059V26.2898C0 26.6822 0.31796 27.0001 0.710358 27.0001H26.2896C26.682 27.0001 27 26.6822 27 26.2898V9.60059L13.9158 19.0501H13.9169ZM3.55286 19.8955H7.10571C7.49811 19.8955 7.81607 20.2134 7.81607 20.6058C7.81607 20.9982 7.49811 21.3162 7.10571 21.3162H3.55286C3.16046 21.3162 2.8425 20.9982 2.8425 20.6058C2.8425 20.2134 3.16046 19.8955 3.55286 19.8955ZM9.94821 24.1587H3.55286C3.16046 24.1587 2.8425 23.8407 2.8425 23.4483C2.8425 23.0559 3.16046 22.738 3.55286 22.738H9.94821C10.3406 22.738 10.6586 23.0559 10.6586 23.4483C10.6586 23.8407 10.3406 24.1587 9.94821 24.1587Z",
    fill: "#52ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3156 11.9527V0.710358C21.3156 0.31796 20.9977 0 20.6053 0H6.39493C6.00253 0 5.68457 0.31796 5.68457 0.710358V11.9527L13.5006 17.5973L21.3167 11.9527H21.3156ZM8.44731 2.95309H18.5529C18.9017 2.95309 19.1846 3.27105 19.1846 3.66345C19.1846 4.05585 18.9017 4.37381 18.5529 4.37381H8.44731C8.09851 4.37381 7.81565 4.05585 7.81565 3.66345C7.81565 3.27105 8.09851 2.95309 8.44731 2.95309ZM7.81565 6.82497C7.81565 6.43257 8.09851 6.11461 8.44731 6.11461H18.5529C18.9017 6.11461 19.1846 6.43257 19.1846 6.82497C19.1846 7.21737 18.9017 7.53533 18.5529 7.53533H8.44731C8.09851 7.53533 7.81565 7.21737 7.81565 6.82497ZM9.71064 9.98649C9.71064 9.59409 9.99351 9.27613 10.3423 9.27613H16.6579C17.0067 9.27613 17.2896 9.59409 17.2896 9.98649C17.2896 10.3789 17.0067 10.6968 16.6579 10.6968H10.3423C9.99351 10.6968 9.71064 10.3789 9.71064 9.98649Z",
    fill: "#52ACBC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 28C31.3137 28 34 25.3137 34 22C34 18.6863 31.3137 16 28 16C24.6863 16 22 18.6863 22 22C22 25.3137 24.6863 28 28 28Z",
    fill: "#FF892A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8729 21.013L27.1911 23.719L31.2883 19.5128",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4103_27671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSuccess);
export default __webpack_public_path__ + "static/media/report-success.ebc251fc2d29b82efc1e612882c179fc.svg";
export { ForwardRef as ReactComponent };